import { useState, useRef } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

import edit from "../../edit.png";
import trash from "../../trash.png";
import icoArrow from '../../Down_Arrow_3_.png'

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

 
import MenuTable from "../../helpers/MenuTable";
import AppContext from "../../AppContext";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import KidPersonNew from "../kids/KidPersonNew";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";








function Pickup(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);



    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''),
        imie: '', 
        nazwisko: '', 
        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,persons', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    
    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', '');

        setFilterParam({
            d_imie_nazwisko: '', 
            imie: '',         
            nazwisko: '',         
            limit: 50,
            page: 1,
            show: true
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
    }





    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = () => {
       
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        getTab();
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

      
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną osobę?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteApproved(id);
                        //--------
        } );
    }

    const goDeleteApproved = (id) => {

 
    

        props.mainView.setProgress(-2);

        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_kids,persons_delete', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Osoba została usunięta", "ok" , null);                        
                        setTab(null);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }



    
 



    if(view.v == 'new')
    {
        return <KidPersonNew  userData={props.userData} mainView={props.mainView} onBack={onBack}  />
    }

 

    return (

        <div className="view_content">
         

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                 {
                    filterParam.show == true  &&
                    <div className="table_filter">

                            <div className="filter_controll">   
                            <label>Dziecko: </label>                             
                            <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  
                    
                            <div className="filter_controll">   
                                <label>Imię: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.imie}   valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię: "}   />
                            </div>  

                            <div className="filter_controll">   
                                <label>Nazwisko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko: "}   />
                            </div>  

                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                    </div>
                }   

       



            <div className="bg_center">


                    <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > nowa osoba</div>

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />

                                &nbsp; &nbsp;
                                <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={"Osoby upoważnione do odbioru dziecka"} />   
                                <Csv tabRef={tab2Ref}  title={ "Osoby upoważnione do odbioru dziecka"} />                  
                                <Xlsx tabRef={tab2Ref}  title={ "Osoby upoważnione do odbioru dziecka"} />                  
                                <Print tabRef={tab2Ref}   title={  "Osoby upoważnione do odbioru dziecka"} />
                    </div>
 
                    <div className="gohide" ref={tabRef}>
                         <h3>Osoby upoważnione do odbioru dziecka</h3>
                        <table className="table" ref={tab2Ref}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td >Dziecko</td>
                                                <td >Nazwisko, imię</td>
                                                <td >Stopień pokrewieństwa</td>
                                                <td >Nr dowodu (4 ost. znaki)</td>   
                                                <td >Data dodania</td>                                                                                                                                                                                                                                  
                                                <td className="td_right">Dodał / zgłosił</td>                                             
                                                                          
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle} key={ix}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="goleft">
                                                                {row.dziecko.nazwisko} {row.dziecko.imie} &nbsp;
                                                                {
                                                                    row.dziecko.archiwalne == "1" &&
                                                                    <span>[Archiwum]</span>
                                                                }
                                                            </td>
                                                            <td className="goleft">{row.nazwisko} {row.imie}</td>
                                                            <td className="gocenter">{row.stopien_pokrewienstwa}</td>
                                                            <td className="goright">*****{row.nr_dowodu_4_ost_znaki}</td>
                                                            <td className="goleft">{row.created_at}</td>                                                       
                                                            <td className="goleft">{row.dodal.nazwisko} {row.dodal.imie}</td>
                                                       
                                                                
                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
                    </div>

                    <div className="scorll_x">
                            <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td >Dziecko</td>
                                                <td >Nazwisko, imię</td>
                                                <td >Stopień pokrewieństwa</td>
                                                <td >Nr dowodu (4 ost. znaki)</td>   
                                                <td >Data dodania</td>                                                                                                                                                                                                                                  
                                                <td className="td_right">Dodał / zgłosił</td>                                             
                                                <td className="td_option"> </td>                                              
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle} key={ix}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="goleft">
                                                                {row.dziecko.nazwisko} {row.dziecko.imie} &nbsp;
                                                                {
                                                                    row.dziecko.archiwalne == "1" &&
                                                                    <span>[Archiwum]</span>
                                                                }
                                                            </td>
                                                            <td className="goleft">{row.nazwisko} {row.imie}</td>
                                                            <td className="gocenter">{row.stopien_pokrewienstwa}</td>
                                                            <td className="goright">*****{row.nr_dowodu_4_ost_znaki}</td>
                                                            <td className="goleft">{row.created_at}</td>                                                       
                                                            <td className="goleft">{row.dodal.nazwisko} {row.dodal.imie}</td>
                                                                                                                    
                                                            <MenuTable>
                                                                        <ul>                                                                 
                                                                            <li onClick={goDelete}  id={row.id} >usuń</li>
                                                                        </ul>
                                                            </MenuTable>
                                                                
                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
                    </div>
            </div>


        </div>

    )

    
}

export default Pickup;